export const APP = 'app';
export const PHOENIX = 'phoenix';
export const VENUE = 'venue';
export const VENUE_PREFIX = `${VENUE}-`;
export const URL_SLASH = '/';
